module.exports = __webpack_public_path__ + "assets/souverenty-small.4eb588e2.svg";